import 'leaflet/dist/leaflet.css'
import L from 'leaflet'
import icon from 'leaflet/dist/images/marker-icon.png'
const DefaultIcon = L.icon({
    iconUrl: icon,
    iconAnchor: [10, 41]
})
L.Marker.prototype.options.icon = DefaultIcon
const createMap = (divId, options) => {
    let map = L.map(divId, options)
    return map
}
const createTileLayer = (map, url, options) => {

    let tileLayer = L.tileLayer(url, options)
    tileLayer.addTo(map)
    return tileLayer
}
export default {
    createMap,
    createTileLayer
}